import { useLocation } from "@tanstack/react-router";
import React, { useEffect } from "react";

export function useOnNavAway(f: () => unknown, deps: React.DependencyList = []) {
    const { href } = useLocation();

    useEffect(() => {
        f();
    }, [href, ...deps]);
}
